import React, { createContext, useState, FC } from 'react';

interface EntityContextProps {
  entityId: string | null;
  entityName: string | null;
  entitySeal: string | null;
  entityType: string | null;
  setEntity: (
    id: string,
    name: string,
    seal: string | null,
    type: string | null
  ) => void;
}

const EntityContext = createContext<EntityContextProps>({
  entityId: null,
  entityName: null,
  entitySeal: null,
  entityType: null,
  setEntity: () => {},
});

export const EntityProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [entityId, setEntityId] = useState<string | null>(null);
  const [entityName, setEntityName] = useState<string | null>(null);
  const [entitySeal, setEntitySeal] = useState<string | null>(null);
  const [entityType, setEntityType] = useState<string | null>(null);

  const setEntity = (
    id: string,
    name: string,
    seal: string | null,
    type: string | null
  ) => {
    setEntityId(id);
    setEntityName(name);
    setEntitySeal(seal);
    setEntityType(type);
  };

  return (
    <EntityContext.Provider
      value={{ entityId, entityName, entitySeal, entityType, setEntity }}
    >
      {children}
    </EntityContext.Provider>
  );
};

export default EntityContext;
